module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8Kgfg"))).then(() => parcelRequire('37nVf'));